var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"body-2",attrs:{"absolute":""}},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"pa-0"},[_c('span',[_vm._v("© "+_vm._s(_vm.year())+" Jiří Pazderník")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }